var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content"},[_c('b',{},[_vm._v("Comment : ")]),_vm._v(" "+_vm._s(this.message)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }